import { FontAwesomeIcon } from '@fortawesome/react-fontawesome'
import React from 'react'

import RespondToInviteButtons from '@/components/misc/CompanyProfile/components/CompanyProfileHeader/RespondToInviteButtons'
import { COMPANY_PROFILE_TAB } from '@/components/misc/CompanyProfile/constants'
import { Button } from '@/components/ui/button'
import { useCompanyProfileSearchParams } from '@/hooks/useCompanyProfileSearchParams'
import { faExclamationTriangle } from '@/lib/fontAwesomePro/regular'
import { cn } from '@/lib/utils'
import { PendingPanelAction } from '@/types/misc'
import { CompanyProfileItemPanel } from '@/types/responses/companies'

interface Props {
  panel: CompanyProfileItemPanel
  pendingActions: PendingPanelAction[]
}

const PendingActionNote: React.FC<Props> = ({ panel, pendingActions }) => {
  const { searchParams, setTab } = useCompanyProfileSearchParams()

  const messages: Record<
    PendingPanelAction,
    {
      label: string
      action?: React.ReactNode
    } | null
  > = {
    respondToInvite: {
      label: 'Respond to invite',
      action: <RespondToInviteButtons panel={panel} />,
    },
    chaseInvite: {
      label: 'Relationship request pending',
    },
    addCommercialAgreement: { label: 'No commercial agreements added' },
    reviewCurrentAgreement: {
      label: 'Commercial agreement(s) pending review',
      action: (
        <Button
          className={cn('self-start', {
            hidden:
              searchParams.profileTab ===
              COMPANY_PROFILE_TAB.commercialAgreements,
          })}
          variant="success"
          size="sm"
          onClick={() => setTab(COMPANY_PROFILE_TAB.commercialAgreements)}
        >
          Review agreement(s)
        </Button>
      ),
    },
    chaseCurrentAgreementReview: {
      label: 'Commercial agreement(s) pending review',
    },
    reviewPendingAgreement: {
      label: 'Commercial agreement(s) pending review',
      action: (
        <Button
          className={cn('self-start', {
            hidden:
              searchParams.profileTab ===
              COMPANY_PROFILE_TAB.commercialAgreements,
          })}
          variant="success"
          size="sm"
          onClick={() => setTab(COMPANY_PROFILE_TAB.commercialAgreements)}
        >
          Review agreement(s)
        </Button>
      ),
    },
    chasePendingAgreementReview: {
      label: 'Commercial agreement(s) pending review',
    },
    reviewCurrentIncomingAgreementConsentLetter: null,
    reviewPendingIncomingAgreementConsentLetter: null,
  }

  const message = pendingActions[0] ? messages[pendingActions[0]] : undefined

  if (!message) {
    return null
  }

  return (
    <div className="flex flex-col justify-start gap-2">
      <div className="text-md text-warning flex items-center gap-2">
        <FontAwesomeIcon icon={faExclamationTriangle} />
        {message.label}
      </div>

      {message.action}
    </div>
  )
}

export default PendingActionNote
